
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormArray, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToolsService } from '../../../core/services/tools.service';
import { StoresService } from '../../../core/services/stores.service';
import { CurrencyPipe } from '@angular/common';
import { LoaderComponent } from '../../../shared-with-client/loader/loader.component';
import { TextInputComponent } from '../../../shared-with-client/text-input/text-input.component';
import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';
import { DropdownInputV2Component } from '../../../shared-with-client/dropdown-input-v2/dropdown-input-v2.component';
import { DropdownInputComponent } from '../../../shared-with-client/dropdown-input/dropdown-input.component';
import { AlertComponent } from '../../../shared-with-client/alert/alert.component';
import { SubmitBtnComponent } from '../../../shared-with-client/submit-btn/submit-btn.component';
import { TranslatePipe } from '@ngx-translate/core';
import { IPosProvider } from '../../../core/services/invoicing.service';

@Component({
    selector: 'app-create-invoice-modal',
    templateUrl: './create-invoice-modal.component.html',
    styleUrls: ['./create-invoice-modal.component.scss'],
    imports: [LoaderComponent, FormsModule, ReactiveFormsModule, TextInputComponent, NgxIntlTelInputModule, DropdownInputV2Component, DropdownInputComponent, AlertComponent, SubmitBtnComponent, CurrencyPipe, TranslatePipe],
    standalone: true
})
export class CreateInvoiceModalComponent implements OnInit {
  public merchant;
  public form: UntypedFormGroup;
  public loading = true;
  public client;
  public bookingServices;

  public currentStore;
  public storeId;
  public errorMsg;
  public submitAttempted;
  public saving;
  public availableProducts;

  public showIsentionReasonDropdown = false;

  public showAddServiceDropdown: boolean = false;

  public isentionReasonsObj = {
    'Artigo 16.°, n.° 6 do CIVA': 'M01',
    'Artigo 6.° do Decreto-Lei n.° 198/90, de 19 de junho': 'M02',
    'Isento artigo 13.° do CIVA	': 'M04',
    'Isento artigo 14.° do CIVA	': 'M05',
    'Isento artigo 15.° do CIVA	': 'M06',
    'Isento artigo 9.° do CIVA	': 'M07',
    'IVA - não confere direito a dedução	': 'M09',
    'IVA - regime de isenção	': 'M10',
    'Regime particular do tabaco	': 'M11',
    'Regime da margem de lucro - Agências de viagens	': 'M12',
    'Regime da margem de lucro - Bens em segunda mão	': 'M13',
    'Regime da margem de lucro - Objetos de arte	': 'M14',
    'Regime da margem de lucro - Objetos de coleção e antiguidades	': 'M15',
    'Isento artigo 14.° do RITI	': 'M16',
    'Outras isenções	': 'M19',
    'IVA - regime forfetário	': 'M20',
    'IVA - não confere direito à dedução (ou expressão similar)	': 'M21',
    'Mercadorias à consignação': 'M25',
    'IVA - autoliquidação	Artigo 2.° n.° 1 alínea i) do CIVA': 'M30',
    'IVA - autoliquidação	Artigo 2.° n.° 1 alínea j) do CIVA': 'M31',
    'IVA - autoliquidação	Artigo 2.° n.° 1 alínea I) do CIVA': 'M32',
    'IVA - autoliquidação	Artigo 2.° n.° 1 alínea m) do CIVA': 'M33',
    'IVA - autoliquidação	Artigo 6.° n.° 6 alínea a) do CIVA, a contrário': 'M40',
    'IVA - autoliquidação	Artigo 8.° n.° 3 do RITI': 'M41',
    'IVA - autoliquidação	Decreto-Lei n.° 21/2007, de 29 de janeiro': 'M42',
    'IVA - autoliquidação	Decreto-Lei n.° 362/99, de 16 de setembro': 'M43',
    'Não sujeito ou não tributado	': 'M99'
  };

  public isentionReasons = [];

  public availablePaymentMethods = [];

  IPosProvider = IPosProvider;

  constructor(
    private fb: UntypedFormBuilder,
    private bsModalRef: BsModalRef,
    private storesService: StoresService,
    private modalService: BsModalService,
    private tools: ToolsService
  ) {}

  get productsFormArray(): UntypedFormArray {
    return this.form.get('products') as UntypedFormArray;
  }

  ngOnInit() {
    this.storeId = this.currentStore.id;

    this.isentionReasons = Object.keys(this.isentionReasonsObj);

    this.storesService.getListOfProductsAndPaymentMethodsForInvoice(this.storeId).subscribe((res) => {
      this.availableProducts = this.mapAvailableProducts(res.products);
      this.availablePaymentMethods = res.paymentMethods;

      this.generateForm(this.client, this.bookingServices);
      this.loading = false;
    });
  }

  mapAvailableProducts(rawData) {
    return rawData.map((elem) => {
      switch (this.currentStore.posProvider) {
        case IPosProvider.MOLONI:
          return {
            name: elem.name,
            value: elem.price,
            tax: elem.taxes?.[0]?.value,
            product_id: elem.product_id,
            tax_id: elem.taxes?.[0]?.tax_id,
            exemption_reason: elem.exemption_reason,
          };
        case IPosProvider.INVOICE_EXPRESS:
          return {
            name: elem.name,
            value: elem.unit_price,
            tax: elem.tax?.value,
            product_id: elem.id,
            tax_id: elem.tax?.name,
            // exemption_reason: elem.exemption_reason,
          };
        default:
          return [];
      }
    });
  }

  validateInvoiceNIF(c: UntypedFormControl) {
    return this.tools.validateInvoiceNIF(c.value) ? null : {
      clientVat: {
        valid: false
      }
    };
  }

  generateForm(clientData = null, bookingServices) {
    let defaultPaymentMethod = null;
    if (this.availablePaymentMethods.length > 0) {
      defaultPaymentMethod = this.availablePaymentMethods.find((method) => method.name === 'Numerário');

      if (!defaultPaymentMethod) {
        defaultPaymentMethod = this.availablePaymentMethods[0];
      }
    }

    this.form = this.fb.group({
      clientVat: [(clientData && clientData.vatNumber) || null, [this.validateInvoiceNIF.bind(this)]],
      clientName: [(clientData && clientData.fullName) || '', []],
      clientEmail: [(clientData && clientData.email) || '', []],
      products: this.fb.array([]),
      paymentMethod: [defaultPaymentMethod, []],
      isentionReason: ['', []],
      addProduct: [null],
    });

    const matchedServiceProducts = this.availableProducts.filter((product) => {
      return bookingServices?.find((service) => service.name === product.name);
    });

    if (matchedServiceProducts?.length) {
      matchedServiceProducts.forEach((product) => {
        // todo: check if exists in moloni
        this.productsFormArray.push(this.productToFormGroup(product));
      });
    } else {
      this.showAddServiceDropdown = true;
    }

    this.form.get('addProduct').valueChanges.subscribe((name) => {
      if (name) {
        this.addProduct(this.availableProducts.find((v) => v.name === name));
        setTimeout(() => {
          this.form.patchValue({ addProduct: null });
          this.form.updateValueAndValidity();
        });
      }
    });
  }

  productToFormGroup(product) {
    return this.fb.group({
      name: [product.name, [Validators.required]],
      price: [product.value, [Validators.required]],
      tax: [product.tax, []],
      product_id: [product.product_id, [Validators.required]],
      qty: [1],
      tax_id: [product.tax_id],
      exemption_reason: [product.exemption_reason],
    });
  }

  addProduct(product) {
    this.productsFormArray.push(this.productToFormGroup(product));
    this.checkIfItemIsent(this.productsFormArray.value);
  }

  removeProduct(index) {
    this.productsFormArray.removeAt(index);
    this.checkIfItemIsent(this.productsFormArray.value);
  }

  checkIfItemIsent(products: any[]) {
    if (this.currentStore.posProvider === IPosProvider.INVOICE_EXPRESS) {
      const foundIsent = products.find((p) => p.tax_id && p.tax_id === 'Isento');

      if (foundIsent) {
        this.form.get('isentionReason').setValidators([Validators.required]);
        this.showIsentionReasonDropdown = true;
      } else {
        this.form.get('isentionReason').setValidators([]);
        this.showIsentionReasonDropdown = false;
      }

      this.form.get('isentionReason').updateValueAndValidity();
    }
  }

  getTotalValue(list) {
    return list.map((v) => this.getProductPrice(v.price, v.tax)).reduce((a, b) => a + b);
  }

  save() {
    this.errorMsg = null;
    this.submitAttempted = true;

    if (this.form.valid === false) {
      return false;
    }

    this.saving = true;

    const products = this.form.get('products').value?.map((product) => {
      return {
        name: product.name,
        product_id: product.product_id,
        qty: product.qty,
        price: product.price,
        taxes: product.tax_id ? [{ tax_id: product.tax_id }]: [],
        exemption_reason: product.exemption_reason,
      };
    });

    const isentionReason = this.form.get('isentionReason').value;
    const payload = {
      clientName: this.form.get('clientName').value,
      clientVat: this.form.get('clientVat').value,
      clientEmail: this.form.get('clientEmail').value,
      bookingId: this.client?.bookingId,
      products,
      taxExemption: this.showIsentionReasonDropdown && isentionReason && this.isentionReasonsObj[isentionReason],
      totalValue: this.getTotalValue(this.productsFormArray.value),
      paymentMethodId: this.form.get('paymentMethod').value?.id,
    };

    this.storesService.createInvoice(this.storeId, payload).subscribe(
      (res) => {
        window.open(res?.invoice);
        this.saving = false;
        this.modalService.setDismissReason('saved');
        this.bsModalRef.hide();
      },
      (err) => {
        this.errorMsg = err.errMsg;
        this.saving = false;
      }
    );
  }

  close() {
    this.bsModalRef.hide();
  }

  getProductPrice(price, tax) {
    switch (this.currentStore.posProvider) {
      case IPosProvider.MOLONI:
        return price + tax;
      case IPosProvider.INVOICE_EXPRESS:
        return price * (1 + tax / 100);
      default:
        return 0;
    }
  }
}
